<template>
  <div class="form-group">
    <address-form :default-item="defaultItem" />
  </div>
</template>

<script setup>
import AddressForm from "@component_path/pages/pc/agent_selection/secret/components/form_item/Address/Select";
import { computed } from "vue";

const defaultItem = computed(() => {
  return {
    value: null,
    label: "こだわらない"
  };
});
</script>
